"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackedAvatar = void 0;

var React = __importStar(require("react"));

var core_1 = require("@emotion/core");

var utils_1 = require("../../utils");

var lseds_1 = require("../../lseds"); // @ts-ignore


exports.StackedAvatar = utils_1.forwardRef(function AvatarStacked(props, ref) {
  var avatar = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t"], ["\n\t\tdisplay: flex;\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: avatar
  }, React.Children.map(props.children, function (child, index) {
    return React.cloneElement(child, __assign(__assign({}, props), {
      stacked: true,
      total: props.children.length,
      index: index
    }));
  }));
});
var templateObject_1;